interface Props {
  type: IconType
  className?: string
}

export type IconType = keyof typeof iconMap

const iconMap = {
  ArrowRight: 'arrow_right_alt',
  ArrowBack: 'arrow_back',
  Contact: 'forum',
  Map: 'near_me',
  Location: 'location_on',
} as const

export default function Icon({ className, type }: Props) {
  return <span className={`material-symbols-outlined text-3xl ${className}`}>{iconMap[type]}</span>
}
